import Seo from "../../components/Seo/Seo";
import Wrapper from "../../layout/wrapper/Wrapper";
import {
  Avatar,
  Backdrop,
  Box,
  Button,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  styled,
} from "@mui/material";
import moment from "moment";
import React, { useCallback, useState } from "react";
import styles from "../../styles/pages/hubuser.module.scss";
// import Image from "next/image";
import assest from "../../json/assest";
import { Link } from "react-router-dom";
import Switch from "@mui/material/Switch";
import ArrowUp from "../../ui/Icons/ArrowUp";
import { useToggle } from "../../hooks/useToggle";
import SettingsModal from "../../ui/Modal/SettingsModal";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  totaluserList,
  totaluserListstatusChangeMutation,
} from "../../api/functions/user.api";
// import { TotalAlusers } from "@/types/common.type";
import SavingLoader from "../../components/ModalTables/SavingLoader/SavingLoader";
import { number } from "prop-types";
import Pagination from "../../components/UtilitiesComponent/Pagination";
import NOprofileImage from "../../public/assets/images/no-image.svg";
import {
  getAbsoluteImageURI,
  getUtcDate,
  getUtcTime,
} from "../../lib/functions/utils.lib";
import PaginationTwo from "../../components/UtilitiesComponent/PaginationTwo";
import ArrowDown from "../../ui/Icons/ArrowDown";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 21,
  height: 13,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 13,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: "2px",
    "&.Mui-checked": {
      transform: "translateX(8px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#177ddc" : "#111AE9",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 9,
    height: 9,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === "dark" ? "rgba(255,255,255,.35)" : "#D4DBDE",
    boxSizing: "border-box",
  },
}));

const Hubuser = () => {
  const [state, setState] = useState(false);
  const [check_id, setcheck_id] = useState();
  const [openSettingsModal, setOpenSettingsModal] = useState(false);
  const [page, setPage] = useState(1);
  const [dateValue, setDateValue] = useState("");
  const [sort, setSort] = useState(false);
  const { mutateAsync: AlluserStatusChangeMutationAA } = useMutation({
    mutationFn: totaluserListstatusChangeMutation,
  });

  const { data: Totaluser, isLoading } = useQuery(
    ["totalusersList", page, sort],
    async () => {
      return totaluserList({
        page,
        sort,
      });
    }
  );

  const queryClient = useQueryClient();
  const onSubmit = () => {
    const formData = new FormData();

    formData.append("user_id", check_id);

    AlluserStatusChangeMutationAA(formData).then(() => {
      setSnackOpen(true);
      setOpenSettingsModal(false);
      queryClient.invalidateQueries(["totalusersList", page]);
    });
  };
  const [SelecteData, setSelecteddata] = useState("");

  const handleOpenSettingsModal = useCallback((_id) => {
    setOpenSettingsModal(true);
    setSelecteddata(_id);
  }, []);

  const handleCloseSettingsModal = useCallback(() => {
    setOpenSettingsModal(false);
  }, []);

  const [snackOpen, setSnackOpen] = React.useState(false);

  const handleClick = () => {
    setOpenSettingsModal(false);
    setSnackOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen(false);
    setOpenSettingsModal(false);
  };

  // const action = (
  //   <React.Fragment>
  //     <Button color="secondary" size="small" onClick={handleClose}>
  //       UNDO
  //     </Button>
  //     <IconButton
  //       size="small"
  //       aria-label="close"
  //       color="inherit"
  //       onClick={handleClose}
  //     >
  //       <CloseIcon fontSize="small" />
  //     </IconButton>
  //   </React.Fragment>
  // );

  const handlePageChange = (e) => {
    setPage(e);
  };

  const handleSort = () => {
    setSort(!sort);
  };

  function lastLogin(apiDate) {
    const lastLoginDate = moment(apiDate, "YYYY-MM-DD HH:mm:ss");

    const now = moment();
    const minutesAgo = now.diff(lastLoginDate, "minutes");

    if (minutesAgo < 1) {
      return "Just now";
    } else if (minutesAgo < 60) {
      return `${minutesAgo} minutes ago`;
    } else if (minutesAgo < 1440) {
      if (minutesAgo < 2880) {
        return "Yesterday";
      } else {
        return `${Math.floor(minutesAgo / 60)} hours ago`;
      }
    } else if (minutesAgo < 10080) {
      return `${Math.floor(minutesAgo / 1440)} days ago`;
    } else {
      return (
        <>
          <p>{getUtcDate(apiDate)}</p>
          <p>{getUtcTime(apiDate)}</p>
        </>
      );
      //  return `${getUtcDate(apiDate)} ${getUtcTime(apiDate)}`
    }
  }

  return (
    <Wrapper>
      <Box className="main_body">
        <Box className={styles.pageHubuserWrapper}>
          <Box className={styles.hubUserTable}>
            <Stack
              direction="row"
              alignItems="center"
              flexWrap="wrap"
              className={styles.userHeading}
            >
              <figure>
                <img src={assest.Icongrid} width={10} height={10} alt="icon" />
              </figure>
              <Typography variant="body2">
                HUB Users: {Totaluser?.total}
              </Typography>
            </Stack>
            <Box className={styles.tableResponsive}>
              <TableContainer
                className={`${styles.tableContainerData} ${
                  Totaluser?.data.length < 10 ? `${styles.auto_height}` : ""
                }`}
              >
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell className={styles.thUser}>User</TableCell>
                      <TableCell className={styles.throle}>Role</TableCell>
                      <TableCell className={styles.thlastActive}>
                        Last Active
                      </TableCell>
                      <TableCell className={styles.thDateAdded}>
                        Date Added{" "}
                        <Button onClick={handleSort} className={styles.arrwBtn}>
                          {sort ? <ArrowUp /> : <ArrowDown />}
                        </Button>
                      </TableCell>
                      <TableCell className={styles.thstatus}>Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {isLoading ? (
                      <Backdrop
                        sx={{
                          color: "#fff",
                          zIndex: (theme) => theme.zIndex.drawer + 1,
                        }}
                        open={isLoading}
                        onClick={handleClose}
                        className="loader"
                      >
                        {/* <FadeLoader color="#5C5C5C" /> */}
                        <div className="loader-wrapper">
                          <div className="loaderIcon">
                            <img
                              src={assest.logo_loader}
                              alt="img"
                              width={100}
                              height={100}
                            />
                          </div>
                        </div>
                      </Backdrop>
                    ) : (
                      <>
                        {Totaluser?.data.map((row, index) => (
                          <TableRow>
                            <TableCell className={styles.thUser}>
                              <Stack
                                direction="row"
                                alignItems="center"
                                className={styles.userStack}
                              >
                                {row?.avatar === "users/default.png" ? (
                                  <Avatar
                                    alt="Remy Sharp"
                                    src={NOprofileImage}
                                    sx={{ width: 40, height: 40 }}
                                  />
                                ) : (
                                  <Avatar
                                    alt="Remy Sharp"
                                    src={getAbsoluteImageURI(row?.avatar)}
                                    sx={{ width: 40, height: 40 }}
                                  />
                                )}

                                <Box className={styles.userMediaRight}>
                                  <Typography variant="body2">
                                    {`${row?.name} ${row?.last_name ?? ""}`}
                                  </Typography>
                                  {row?.submission_link ? (
                                    <Link
                                      herf={row?.submission_link}
                                      target="_blank"
                                    >
                                      {row?.submission_link}
                                    </Link>
                                  ) : (
                                    ""
                                  )}
                                </Box>
                              </Stack>
                            </TableCell>
                            <TableCell className={styles.throle}>
                              {row?.role?.display_name}
                            </TableCell>
                            <TableCell className={styles.lastActive}>
                              <Typography variant="body2">
                                {lastLogin(row?.last_login)}
                              </Typography>
                              {/* <Typography variant="caption">
                          {row?.joined_at}
                        </Typography> */}
                            </TableCell>
                            <TableCell className={styles.thDateAdded}>
                              {moment(row?.created_at).format("MMMM D, YYYY")}
                            </TableCell>
                            <TableCell className={styles.thstatus}>
                              <Stack
                                direction="row"
                                alignItems="center"
                                className={styles.showStatus}
                              >
                                <Typography variant="caption">
                                  {/* {row?.status} */}
                                  {row?.status === 1 ? "Active" : "Inactive"}
                                </Typography>
                                <AntSwitch
                                  value={index}
                                  defaultChecked
                                  inputProps={{ "aria-label": "ant design" }}
                                  onChange={(e) => setState(e.target.checked)}
                                  checked={row?.status === 1}
                                  onClick={() => {
                                    handleOpenSettingsModal(row),
                                      setcheck_id(row?.id);
                                  }}
                                />
                              </Stack>
                            </TableCell>
                          </TableRow>
                        ))}
                      </>
                    )}
                    {/* ============================================== */}
                    {/* ======== WHEN THERE ARE NO USER START ======== */}
                    {/* <TableCell className={styles.noUser} colSpan={5}>
                      There are currently no users.
                    </TableCell> */}
                    {/* ============================================== */}
                    {/* ========= WHEN THERE ARE NO USER END ========= */}
                  </TableBody>
                </Table>
              </TableContainer>
              <Box className={styles.viewallTr}>
                {/* Totaluser.last_page  */}
                {/* {Totaluser?.last_page && (
                  <>
                    {page !== 1 && (
                      <Button
                        className={styles.viewmoreBtn}
                        onClick={() => {
                          setPage(page - 1);
                        }}
                      >
                        View less
                      </Button>
                    )}
                    {page < Totaluser?.last_page && (
                      <Button
                        className={styles.viewmoreBtn}
                        onClick={() => {
                          setPage(page + 1);
                        }}
                      >
                        View more
                      </Button>
                    )}
                  </>
                )} */}
                {Totaluser?.total > 10 ? (
                  <PaginationTwo
                    page={page}
                    count={Totaluser?.last_page}
                    handleChange={handlePageChange}
                  />
                ) : (
                  ""
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      <SettingsModal
        open={openSettingsModal}
        onClose={handleCloseSettingsModal}
        hideBackdrop
      >
        <Box className={styles.modalContent}>
          <figure>
            <img
              src={assest.IconExclamatory}
              width={7}
              height={31}
              alt="icon"
            />
          </figure>
          <Typography variant="h3">
            Are you sure you want to {state ? "reactivate" : "deactivate"} this
            user?
          </Typography>
          <Typography variant="body1">
            {SelecteData?.name} <span>({SelecteData?.role?.name})</span>
          </Typography>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            className={styles.btnGroup}
          >
            <Button className={styles.btnBlack} onClick={onSubmit}>
              {state ? "Reactivate" : "Deactivate"}
            </Button>
            <Button
              className={styles.btnGray}
              onClick={handleCloseSettingsModal}
            >
              Cancel
            </Button>
          </Stack>
        </Box>
      </SettingsModal>
      <Backdrop
        open={snackOpen || openSettingsModal}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
        onClick={handleClose}
      >
        <Snackbar
          open={snackOpen}
          autoHideDuration={1500}
          onClose={handleClose}
          message={`User ${state ? "Reactivated" : "Deactivated"} Successfully`}
          // action={action}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          ContentProps={{
            sx: {
              justifyContent: "center",
              minWidth: "260px !important",
              background: "#000",
              boxShadow: "0px 0px 3px 1px rgba(0, 0, 0, 0.5)",
              height: "45px",
              padding: 0,
              "& .MuiSnackbarContent-message": {
                fontWeight: "500",
                fontSize: "13px",
              },
            },
          }}
        />
      </Backdrop>
    </Wrapper>
  );
};

export default Hubuser;
